const PendingPropertyFilters = ({
    filters,
    onChange,
}) => {
    return (
        <div className="mb-4 flex gap-4 flex-wrap">
            <input
                type="text"
                name="title"
                value={filters.title}
                onChange={onChange}
                placeholder="Tiêu đề"
                className="border px-3 py-1 rounded"
            />

            <input
                type="text"
                name="projectName"
                value={filters.projectName}
                onChange={onChange}
                placeholder="Tên dự án"
                className="border px-3 py-1 rounded"
            />

            <select
                name="propertyType"
                value={filters.propertyType}
                onChange={onChange}
                className="border px-3 py-1 rounded"
            >
                <option value="">Tất cả</option>
                <option value="apartment">Căn hộ</option>
                <option value="villa">Biệt thự</option>
                <option value="shophouse">Shophouse</option>
                <option value="condotel">Condotel</option>
                <option value="penthouse">Penthouse</option>
                <option value="duplex">Duplex</option>
            </select>
        </div>
    );
};

export default PendingPropertyFilters;